import { render, staticRenderFns } from "./modalDetalleCarpeta.vue?vue&type=template&id=7dc37470"
import script from "./modalDetalleCarpeta.vue?vue&type=script&lang=js"
export * from "./modalDetalleCarpeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports